import {IPlayerChannel} from "../interfaces/IPlayerUIState.ts";
import {IEpgItem} from "../interfaces/IEpgItem.ts";
import DateHelper from "./dateHelper.ts";

export default class PlayerUIHelpers {
  public static getDataIdAttr = (elementId: number) => {
    const element = document.getElementById(elementId.toString());
    if (element) {
      const dataIdAttrValue = element.getAttribute("data-id");
      if (dataIdAttrValue)
        return Number(dataIdAttrValue);
    }
  }
  public static scrollToEpg = (channelIndex: number, epgIndex: number, isSmoothScroll: boolean) => {
    const epgListElem = document.getElementById(`${channelIndex}epgScroll`);
    if (epgListElem) {
      const epgToScroll = epgListElem.querySelector(`[data-epg-id="${epgIndex}"]`);
      epgToScroll?.scrollIntoView({behavior: isSmoothScroll ? "smooth" : "instant"});
    }
  }

  public static getActualEpgItem = (channel: IPlayerChannel): IEpgItem | undefined =>
      channel.epgList.find(x => x.start_timestamp <= DateHelper.GetDateTimeNowAsUnixTimespan() && x.stop_timestamp > DateHelper.GetDateTimeNowAsUnixTimespan());

  public static scrollToChannel = (index: number, smooth: boolean = true) => {
    const channelToScrollElem = document.getElementById(index.toString());
    if (channelToScrollElem) {
      channelToScrollElem.scrollIntoView({
        behavior: smooth ? "smooth" : "instant"
      });
    }
  };
}